import { brandVoiceServiceClient } from 'services/backofficeIntegration/http/client/createBrandVoiceServiceClient';
import { targetAudienceServiceClient } from 'services/backofficeIntegration/http/client/createTargetAudienceServiceClient';
import { queryEndpoint } from 'services/backofficeIntegration/http/endpointDefinition';
import { ModelsBrandVoice } from 'services/backofficeIntegration/http/endpoints/new-brand-voice/httpCreateBrandVoice';
import { ModelTargetAudience } from 'services/backofficeIntegration/http/endpoints/target-audience/httpGetTargetAudiences';
import { brandVoicesQueryKeys } from 'services/backofficeIntegration/http/queryKeyFactories/brandVoicesQueryKeys';
import { targetAudiencesQueryKeys } from 'services/backofficeIntegration/http/queryKeyFactories/targetAudiencesQueryKeys';

type GetTargetAudienceByIdParams = {
  workspaceId: string;
  targetAudienceId: string;
};

type GetTargetAudienceByIdSuccessDto = ModelTargetAudience;

export const httpGetTargetAudienceById = queryEndpoint({
  makeQueryKey: (params: GetTargetAudienceByIdParams) => {
    return [...targetAudiencesQueryKeys.forTargetAudienceById(params.targetAudienceId)] as const;
  },
  callEndpoint: ({ workspaceId, targetAudienceId }: GetTargetAudienceByIdParams) => {
    return targetAudienceServiceClient
      .get<GetTargetAudienceByIdSuccessDto>(
        `workspaces/${workspaceId}/target-audiences/${targetAudienceId}`
      )
      .then(response => response.data);
  }
});
